import axiosApiInstance from "../../../app/axios";
import { PARKIT_API_BASE_URL } from "../../../app/utils";
import { getJwtToken } from "../../../app/common";

export const getAllReferralCampaigns = async (page, size, sort, sortBy) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const createReferralCampaign = async (data) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns`,
    data,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const updateReferralCampaign = async (id, data) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}`,
    data,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const getReferralTerms = async (id) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}/terms`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const generateReferralTerms = async (id, prompt) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}/terms/generate`,
    { prompt },
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const saveReferralTermsDraft = async (id, markdown, prompt) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}/terms/draft`,
    { markdown, prompt },
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const discardReferralTermsDraft = async (id) =>
  axiosApiInstance.delete(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}/terms/draft`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const restoreReferralTermsDraft = async (id) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}/terms/draft-from-published`,
    {},
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const publishReferralTerms = async (id) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/campaigns/${id}/terms/publish`,
    {},
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );
